import { HospitalQueueRowData } from '../../socket/stream-types';
import { QueueStore } from '../../queues/store/queue-store';
import { action, makeObservable } from 'mobx';
import { WorkspacePanelWithQueue } from '../../panels/workspace-queue-exists';
import { QueueAttributeFilter } from '@mark43/cad-api';

export class HospitalQueueStore extends QueueStore<HospitalQueueRowData> {
    constructor(workspacePanel: WorkspacePanelWithQueue) {
        super({
            workspacePanel,
        });

        makeObservable(this);
    }

    private attributeToQueueFilter(
        id: number,
        type: 'HOSPITAL_STATUS' | 'HOSPITAL_CAPABILITY'
    ): QueueAttributeFilter {
        return {
            attributeId: id,
            attributeType: type,
            queueId: this.workspacePanel.queue.id,
        };
    }

    @action
    setHospitalStatusAttributeIds(hospitalStatusAttrIds: number[]): void {
        this.workspacePanel.queue.hospitalStatusFilters = hospitalStatusAttrIds.map((id: number) =>
            this.attributeToQueueFilter(id, 'HOSPITAL_STATUS')
        );
    }

    @action
    setHospitalCapabilityAttributeIds(hospitalCapabilityAttrIds: number[]): void {
        this.workspacePanel.queue.hospitalCapabilityFilters = hospitalCapabilityAttrIds.map(
            (id: number) => this.attributeToQueueFilter(id, 'HOSPITAL_CAPABILITY')
        );
    }
}
